const translations = {
  'nav.home': 'ホーム',
  'nav.service': '事業内容',
  'nav.company': '会社概要',

  'company.brand': '株式会社ノヴォブ',

  'hero.headline': '人と企業の「最適」をつなぎ、\n新たな価値を創造する。',
  'hero.subheadline': '株式会社ノヴォブ は、スタートアップならではのスピード感と丁寧なマッチングで、理想のキャリアと理想の組織作りをサポートします。',

  'service.title': '事業内容',


  'company.title': '会社概要',
  'company.name': '商号',
  'company.nameValue': '株式会社ノヴォブ',
  'company.ceo': '代表者',
  'company.ceoValue': '代表取締役\u3000原田純輝',
  'company.founded': '設立',
  'company.address': '所在地',
  'company.addressValue': '千葉県山武市五木田2658番地15',
  'company.capital': '資本金',
  'company.capitalValue': '2000万円',
  'company.business': '事業内容',
  'company.businessValue': '',
  'company.license': '許認可番号',

  'footer.copyright': '© 2026 ノヴォブ Inc.',
};

export default translations;